//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Icon } from 'vant'
import { isOverflown } from '@utils/utils'

export default {
  components: { Icon },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      status: 'close',
      isOverflown: false,
    }
  },

  computed: {
    clz () {
      return this.status === 'OPEN' ? 'open'
        : this.status === 'CLOSE' ? 'close'
          : ''
    },

    showOpen () {
      return this.status === 'close' && this.isOverflown
    },

    showClose () {
      return this.status === 'open' && this.isOverflown
    },
  },

  mounted () {
    this.isOverflown = isOverflown(this.$refs.wrapper)
  },

  methods: {
    open () {
      this.status = 'open'
    },

    close () {
      this.status = 'close'
    },

  },
}
